<template>
  <div class="choice-eb">
    <transition appear name="fade">
      <div class="container">
        <div class="row">
          <div class="col">
            <Button
              theme="yellow"
              arrow="begin"
              shape="minimal"
              class="back"
            >
              <router-link to="/">
                <span class="slot">Terug naar begin</span>
              </router-link>
            </Button>

            <h1
              v-if="currentStep.title"
              class="title"
            >{{ currentStep.title }}</h1>

            <div
              class="content"
              v-if="currentStep.body"
              v-html="currentStep.body"
            ></div>

            <ul
              class="list"
              v-if="currentStep.buttons"
            >
              <li
                v-for="(button, index) in currentStep.buttons"
                :key="index"
                class="item"
              >
                <template v-if="button.modal">
                  <Button theme="white">
                    <span @click="showModal = ('modal' + index)">
                      {{ button.text }}
                    </span>
                  </Button>

                  <Modal
                    v-if="showModal == 'modal' + index"
                    :ref="'modal' + index"
                    @close="showModal = false"
                  >
                    <img
                      v-if="button.modalImage"
                      draggable="false"
                      slot="image"
                      alt=""
                      :src="require('@/assets/images/flowchart/' + button.modalImage)"
                    />

                    <h2
                      v-if="button.modalTitle"
                      slot="title">{{ button.modalTitle }}</h2>

                    <div slot="body" v-html="button.modalText"></div>

                    <ul class="list" slot="buttons">
                      <li
                        v-for="(item, j) in button.links"
                        :key="j"
                        class="item"
                      >
                        <Button theme="yellow">
                          <a
                            :href="item.href"
                            target="_blank"
                            class="slot"
                          >
                            {{ item.text }}
                          </a>
                        </Button>
                      </li>

                      <li
                        v-if="button.route"
                        class="item"
                      >
                        <Button theme="yellow">
                          <router-link class="slot" :to="button.route">
                            Volgende
                          </router-link>
                        </Button>
                      </li>
                    </ul>
                  </Modal>
                </template>
                <template v-else>
                  <Button theme="white">
                    <router-link class="slot" :to="button.route">
                      {{ button.text }}
                    </router-link>
                  </Button>
                </template>
              </li>
            </ul>
          </div>

          <div class="media">
            <figure
              v-if="currentStep.image"
              class="figure"
            >
              <img
                draggable="false"
                alt=""
                class="image"
                :src="require('@/assets/images/flowchart/' + currentStep.image)"
              />
            </figure>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import json from '@/../static/flow.json'
import Button from '@/components/Button'
import Modal from '@/components/Modal'

export default {
  name: 'ChoiceEB',
  components: { Button, Modal },
  data () {
    return {
      currentStep: {},
      showModal: false
    }
  },
  methods: {
    getCurrent (path) {
      return json.museum.filter(i => i.route === path)
    },
    setCurrent (path) {
      this.currentStep = this.getCurrent(path)[0]
    }
  },
  created () {
    this.setCurrent(this.$route.fullPath)
  }
}
</script>

<style lang="scss" scoped>
  .choice-eb {

  }
  .back {
    margin-bottom: 24px;
  }
  .container {
    @extend %container;
    padding-top: 70px;
    padding-bottom: 70px;

    @media (max-width: 1381px) {
      padding-top: 46px;
      padding-bottom: 46px;
    }
  }
  .row {
    @extend %row;
  }
  .col, .media {
    @extend %col-md-6;
  }
  .media {
    @media (max-width: 991px) {
      margin-top: 20px;
    }
  }
  .title {
    margin-top: 0;
    margin-bottom: 0.71em;
  }

  .list {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  .item {
    margin: 0;
    display: inline-block;
    font-size: 0;
    margin-bottom: 15px;
    margin-right: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/domains/ChoiceEB.vue